import type { FC } from 'react';
import React, { useRef } from 'react';
import classnames from 'classnames';
import { useTranslations } from 'hooks/useTranslations';
import styles from './BurgerButton.module.scss';
type BurgerButtonProps = {
  isOpen: boolean;
  bgBlack?: boolean;
  label?: string;
  toggleMenu: () => void;
};
export const BurgerButton: FC<BurgerButtonProps> = ({
  isOpen,
  toggleMenu,
  bgBlack,
  label,
}) => {
  const { t } = useTranslations();
  const lines = useRef<Array<number>>(Array.from(Array(3), () => 1));

  return (
    <button
      onMouseDown={toggleMenu}
      id="menu-btn"
      className={classnames(styles.burgerButton, { [styles.opened]: isOpen })}
    >
      <div className="flex items-center gap-3">
        <div className="min-w-[20px]">
          {lines.current.map((item, idx) => (
            <span
              key={idx}
              className={classnames(styles.lines, {
                [`!bg-primaryBlack`]: bgBlack,
              })}
            />
          ))}
        </div>
        <span
          className={classnames(styles.menuTextContainer, {
            [styles.menuOpen]: isOpen,
          })}
        >
          {label ? (
            <span
              className={classnames(
                styles.menuText,
                'text-nowrap !font-avant-garde text-lg pl-[5px]',
                {
                  [`!text-primaryBlack`]: bgBlack,
                },
              )}
            >
              {label}
            </span>
          ) : (
            <>
              <span
                className={classnames(styles.menuText, 'text-sm leading-7', {
                  [`!text-primaryBlack`]: bgBlack,
                })}
              >
                Menu
              </span>
              <span
                className={classnames(styles.menuText, 'text-sm leading-7', {
                  [`!text-primaryBlack`]: bgBlack,
                })}
              >
                {t('CLOSE_BUTTON_LABEL')}
              </span>
            </>
          )}
        </span>
      </div>
    </button>
  );
};
